import React from 'react';
import PropTypes from 'prop-types';
import GiftIcon from '../../../shared/icons/icon-free-gift-with-purchase.svg';
import InfoModal from '../../../shared/components/InfoModal/InfoModal';


const PromotionBanner = function PromotionBannerComponent(props) {
  const {
    body,
    modalHeadingLarge,
    modalHeadingSmall,
    modalMarkdown,
    modalTrigger,
    modalContentLabel,
    title,
    type,
  } = props;


  return (
    <div className="product-addon__text-promotion">
      <div className="product-details__promotion">
        {type === 'gift' && <GiftIcon className="product-details__promotion-icon-gift" />}
        <div>
          <h3 className="product-details__promotion-title">
            {title}
          </h3>
          <div className="info_modal__promotion-trigger-label">
            {body}
          </div>
          {' '}
          <InfoModal
            styleFlag="promotion"
            message={modalMarkdown}
            contentLabel={modalContentLabel}
            subheader={modalHeadingSmall}
            header={modalHeadingLarge}
            headerIcon={<GiftIcon />}
          >
            {modalTrigger}
          </InfoModal>
        </div>
      </div>
    </div>
  );
};

PromotionBanner.propTypes = {
  body: PropTypes.string,
  modalHeadingLarge: PropTypes.string,
  modalHeadingSmall: PropTypes.string,
  modalMarkdown: PropTypes.string,
  modalTrigger: PropTypes.string,
  modalContentLabel: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};

PromotionBanner.defaultProps = {
  body: '',
  modalHeadingLarge: '',
  modalHeadingSmall: '',
  modalMarkdown: '',
  modalTrigger: '',
  modalContentLabel: '',
  title: '',
  type: '',
};

export default PromotionBanner;
